import { onUnsubscribeFromBrand } from '../actions/internalActions';
import { onAfterUnsubscribe, UnsubscribeResponseType } from 'owa-brands-subscription';
import { confirm } from 'owa-confirm-dialog';
import strings from 'owa-strings/owa-mail-strings';
import { orchestrator } from 'satcheljs';

export default orchestrator(onAfterUnsubscribe, actionMessage => {
    if (actionMessage.unsubscribeSourceType !== 'SubscriptionHub') {
        return;
    }

    if (actionMessage.responseType === UnsubscribeResponseType.Success) {
        onUnsubscribeFromBrand(actionMessage.smtpIdentifier);
    } else {
        confirm(
            strings.unsubscribeDialogActionFailed,
            strings._unsubscribeDialogActionFailedText,
            false,
            {
                hideCancelButton: true,
            }
        );
    }
});
